<template>
  <DefaultLayout />
  
  <widget-container-modal />
</template>

<script>
import DefaultLayout from './layouts/DefaultLayout.vue'
    import {container} from "jenesius-vue-modal";

export default {
  name: 'App',
  components: {
    DefaultLayout,
    WidgetContainerModal: container
  }
}
</script>





<style>

</style>
